// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-range-picker-navButton-mo7lG {
  width: 36px;
  height: 36px;
  padding: 6px;
  color: var(--color-neutral-700);
}

.date-range-picker-dateRangeContainer-F_gDl {
  display: flex;
}

.date-range-picker-options-cf6r4 {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
  max-height: 360px;
  border-right: 1px solid var(--color-neutral-200);
  padding: 12px;
  overflow: auto;
}

.date-range-picker-option-_U34B {
  min-width: 140px;
  font-size: 14px;
  color: var(--color-neutral-700);
  cursor: pointer;
  padding: 8px 12px;
  border-radius: var(--radius-lg);
  transition: background-color 200ms;
}

.date-range-picker-option-_U34B:hover {
  background-color: var(--hover-color);
}

.date-range-picker-option-_U34B:active {
  background-color: var(--active-color);
}

.date-range-picker-optionSelected-WMv5z {
  background-color: var(--hover-color);
  color: var(--color-neutral-900);
}

.date-range-picker-dateRange-PkA0P {
  padding: 12px 12px 12px 12px;
}

.date-range-picker-dateRangeFooter-fzSe2 {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid var(--color-neutral-200);
  padding: 8px 12px;
}

.date-range-picker-button_base-AUtCG {
  height: 32px;
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/date-range-picker/date-range-picker.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;EAChD,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".navButton {\n  width: 36px;\n  height: 36px;\n  padding: 6px;\n  color: var(--color-neutral-700);\n}\n\n.dateRangeContainer {\n  display: flex;\n}\n\n.options {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 140px;\n  max-height: 360px;\n  border-right: 1px solid var(--color-neutral-200);\n  padding: 12px;\n  overflow: auto;\n}\n\n.option {\n  min-width: 140px;\n  font-size: 14px;\n  color: var(--color-neutral-700);\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: var(--radius-lg);\n  transition: background-color 200ms;\n}\n\n.option:hover {\n  background-color: var(--hover-color);\n}\n\n.option:active {\n  background-color: var(--active-color);\n}\n\n.optionSelected {\n  background-color: var(--hover-color);\n  color: var(--color-neutral-900);\n}\n\n.dateRange {\n  padding: 12px 12px 12px 12px;\n}\n\n.dateRangeFooter {\n  display: flex;\n  justify-content: flex-end;\n  border-top: 1px solid var(--color-neutral-200);\n  padding: 8px 12px;\n}\n\n.button_base {\n  height: 32px;\n  margin-left: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navButton": `date-range-picker-navButton-mo7lG`,
	"dateRangeContainer": `date-range-picker-dateRangeContainer-F_gDl`,
	"options": `date-range-picker-options-cf6r4`,
	"option": `date-range-picker-option-_U34B`,
	"optionSelected": `date-range-picker-optionSelected-WMv5z`,
	"dateRange": `date-range-picker-dateRange-PkA0P`,
	"dateRangeFooter": `date-range-picker-dateRangeFooter-fzSe2`,
	"button_base": `date-range-picker-button_base-AUtCG`
};
export default ___CSS_LOADER_EXPORT___;
